import { cn } from '@/ui/utils';

const PIXELS_PER_SECOND = 40;

export function HoverScrollText({ className, children, ...props }: React.ComponentProps<'span'>) {
  return (
    <span
      ref={(outer) => {
        const inner = outer?.firstElementChild;
        if (!outer || !(inner instanceof HTMLElement)) return;
        const trigger = outer.closest('a, button, [role=button]') ?? outer;
        const start = () => {
          const distance = inner.scrollWidth - outer.clientWidth;
          if (distance <= 0) return;
          if (matchMedia('(prefers-reduced-motion: reduce)').matches) {
            outer.title = inner.textContent ?? '';
            return;
          }
          outer.style.setProperty('--scroll-distance', `-${distance}px`);
          outer.style.setProperty('--scroll-duration', `${distance / PIXELS_PER_SECOND}s`);
          outer.dataset.active = '';
          outer.dataset.scrolling = '';
        };
        const stop = () => delete outer.dataset.scrolling;
        const reset = () => {
          if ('scrolling' in outer.dataset || inner.getAnimations().length) return;
          delete outer.dataset.active;
        };
        trigger.addEventListener('pointerenter', start);
        trigger.addEventListener('pointerleave', stop);
        inner.addEventListener('transitionend', reset);
        inner.addEventListener('transitioncancel', reset);
        return () => {
          trigger.removeEventListener('pointerenter', start);
          trigger.removeEventListener('pointerleave', stop);
          inner.removeEventListener('transitionend', reset);
          inner.removeEventListener('transitioncancel', reset);
        };
      }}
      className={cn(
        'group/scroll-text block min-w-0 overflow-hidden',
        'data-scrolling:[mask-image:linear-gradient(to_right,transparent,black_1rem)]',
        className,
      )}
      {...props}
    >
      <span className="inline-block max-w-full truncate align-top transition-transform duration-300 ease-out group-data-active/scroll-text:max-w-none group-data-scrolling/scroll-text:translate-x-(--scroll-distance) group-data-scrolling/scroll-text:delay-300 group-data-scrolling/scroll-text:duration-(--scroll-duration) group-data-scrolling/scroll-text:ease-linear">
        {children}
      </span>
    </span>
  );
}
